<div>
    <navigation [pageScrolled]="pageScrolled"></navigation>
    <router-outlet></router-outlet>
    <footer></footer>
</div>
<cookies-modal></cookies-modal>